export const MAP_THEMES = ['light', 'dark', 'satellite'];

export function cycleTheme(theme) {
  if (theme === 'light') return 'dark';
  if (theme === 'dark') return 'satellite';
  return 'light';
}

export function getTileLayerConfig(theme) {
  const cartoKey = process.env.REACT_APP_CARTO_KEY;
  if (theme === 'satellite') {
    return {
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      opacity: 1,
      attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
      // Allow deep zoom in every view: beyond the provider's native tiles
      // Leaflet upscales the last available tiles instead of showing blanks.
      maxZoom: 26,
      maxNativeZoom: 19,
    };
  }
  return {
    url: theme === 'dark'
      ? `https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png?key=${cartoKey}`
      : `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png?key=${cartoKey}`,
    opacity: 0.8,
    attribution: '',
    maxZoom: 26,
    maxNativeZoom: 20,
  };
}

export function themeToggleTitle(theme) {
  if (theme === 'satellite') return 'Passa a tema chiaro';
  if (theme === 'dark') return 'Passa a satellite';
  return 'Passa a tema scuro';
}
